import { render, staticRenderFns } from "./djgz.vue?vue&type=template&id=183988f8&scoped=true"
import script from "./djgz.vue?vue&type=script&lang=js"
export * from "./djgz.vue?vue&type=script&lang=js"
import style0 from "./djgz.vue?vue&type=style&index=0&id=183988f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "183988f8",
  null
  
)

export default component.exports